import "./styles/index.css";

class Main {
    constructor() {
        for (const element of document.getElementsByClassName("get-started-btn")) {
            element.target = "_blank";
            element.href =
                process.env.NODE_ENV === "production"
                    ? "https://apply.loanglide.com/direct/azibo/"
                    : "https://apply-qa.loanglide.com/direct/azibo/";
        }
    }
}

new Main();
